export default __webpack_public_path__ + "static/media/maypay_logo_probability.845445b6.svg";